import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import RichText from "@qlik/qlik/src/components/RichText";
import * as styles from "./styles.module.css";

/**
 * Template component for News inner page.
 * It displays the content type and rendering of the passed data.
 *
 * @param {Object} data - The data to be displayed.
 * @returns {JSX.Element} A section element containing the content type and rendering of the data.
 */
const NewsSingleEntry = ({ data }) => {
    const { additionalConfiguration, backgroundColor } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    return (
        <section className={`richtext-content ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {/* Displaying the content type of the data */}
                        {/* eslint-disable-next-line no-underscore-dangle */}
                        {/* Displaying the rendering of the data */}
                        <div className="lg:mx-25">
                            {data.body?.raw && (
                                <div className={`${styles.newsRichtextWrapper}`}>
                                    <RichText data={data} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NewsSingleEntry;
